import { useEffect, useState } from 'react';
import { UploadIcon } from 'lucide-react';

// 첨부는 PromptInput의 globalDrop 핸들러가 처리하고 이 컴포넌트는 오버레이 표시만 담당
export const DragOverlay = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // 자식 요소로 이동할 때마다 dragenter/dragleave가 반복 발생하므로 깊이 카운터로 판정
    let depth = 0;
    const hasFiles = (e: DragEvent) => e.dataTransfer?.types?.includes('Files') ?? false;

    const onDragEnter = (e: DragEvent) => {
      if (!hasFiles(e)) return;
      depth += 1;
      if (depth === 1) setVisible(true);
    };
    const onDragLeave = (e: DragEvent) => {
      if (!hasFiles(e)) return;
      depth = Math.max(0, depth - 1);
      if (depth === 0) setVisible(false);
    };
    const onDrop = (e: DragEvent) => {
      if (!hasFiles(e)) return;
      depth = 0;
      setVisible(false);
    };

    document.addEventListener('dragenter', onDragEnter);
    document.addEventListener('dragleave', onDragLeave);
    document.addEventListener('drop', onDrop);
    return () => {
      document.removeEventListener('dragenter', onDragEnter);
      document.removeEventListener('dragleave', onDragLeave);
      document.removeEventListener('drop', onDrop);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="bg-background/80 pointer-events-none fixed inset-0 z-50 flex flex-col items-center justify-center gap-2">
      <UploadIcon className="text-muted-foreground size-8" />
      <p className="text-base font-medium">이미지, 영상 또는 음원을 놓아 주세요</p>
      <p className="text-muted-foreground text-sm">최대 100MB, 영상은 3분 이하</p>
    </div>
  );
};
